const userService = {
    regsiter: (registrationOptions) => {
        return Collaterate.User.register(registrationOptions)
    },
    login: (loginOptions) => {
        return Collaterate.User.login(loginOptions)
    }
};
export default userService;